import { Icon, Link, Text, WrenchIcon } from 'src/design-system/ui'

import { BusinessPortalWorkspacePicker } from './BusinessPortalWorkspacePicker'
/** Shared by the portal and agent navigation rails. */
export const BusinessPortalWorkspaceControls = ({
  canSelectWorkspace,
  currentPm,
  debugNavItem,
  onDebugClick,
  onPmChange,
  pmNamesLoading,
  workspaces,
}: {
  canSelectWorkspace: boolean
  currentPm: string | null
  debugNavItem: { href: string; isActive: boolean; label: string } | null
  onDebugClick: (href: string) => void
  onPmChange: (nextPm: string | null) => void
  pmNamesLoading: boolean
  workspaces: readonly { pmName: string; displayName: string }[]
}) => {
  if (!canSelectWorkspace && !debugNavItem) return null

  return (
    <div className="ds:grid ds:min-w-0 ds:gap-2 ds:p-4">
      <Text variant="caps" tone="muted">
        Workspace
      </Text>
      {canSelectWorkspace && (
        <BusinessPortalWorkspacePicker
          workspaces={workspaces}
          currentPm={currentPm}
          loading={pmNamesLoading}
          onChange={onPmChange}
        />
      )}
      {debugNavItem && (
        <Link
          variant="navigation"
          href={debugNavItem.href}
          onNavigate={onDebugClick}
          aria-current={debugNavItem.isActive ? 'page' : undefined}
          className="ds:items-center ds:gap-3 ds:p-3"
        >
          <Icon icon={WrenchIcon} size="sm" tone="current" />
          <Text variant="body">{debugNavItem.label}</Text>
        </Link>
      )}
    </div>
  )
}
